import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownProductPriceListExtras', request)
}

async function put(request) {
    return await putMethod('/api/ownProductPriceListExtras', request)
}

async function post(body) {
    return await postMethod('/api/ownProductPriceListExtras', body)
}

export {get, put, post}
